'use strict';

const BaseModel = require('./baseModel');

class ApplicantWorkExperience extends BaseModel {
  constructor(schema = applicantWorkExperienceSchema) {
    super(schema);
  }

  static getSchema() {
    return applicantWorkExperienceSchema;
  }
}

const applicantWorkExperienceSchema = {
  employerName: {
    required: {
      message: 'This field is required.'
    }
  },
  city: {
    required: {
      message: 'This field is required.'
    }
  },
  state: {
    required: {
      message: 'This field is required.'
    }
  },
  typeOfBusiness: {
    required: {
      message: 'This field is required.'
    }
  },
  title: {
    required: {
      message: 'This field is required.'
    }
  },
  department: {
    required: {
      message: 'This field is required.'
    }
  },
  employmentStart: {
    required: {
      message: 'This field is required.'
    }
  },
  contactEmployer: {
    required: {
      message: 'This field is required.'
    }
  },

  // if can contact employer
  supervisorName: {
    required: {
      message: 'This field is required.'
    }
  },
  supervisorEmail: {
    isEmail: {
      message: 'Must be a valid email.'
    }
  },
  supervisorPhoneNumber: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },

  // if can't contact employer
  contactEmployerReason: {
    required: {
      message: 'This field is required.'
    }
  },

  // job summary/specifics
  jobSummary: {
    required: {
      message: 'This field is required.'
    }
  },
  jobSpecifics: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 3},
      message: 'Must provide at least 3'
    }
  }
};

module.exports = ApplicantWorkExperience;



// WEBPACK FOOTER //
// ./shared/models/applicantWorkExperience.js